import Rewards from "@/screens/rewards/old/RewardsScreen"
import NewRewards from "@/screens/rewards/RewardsScreen"
import { useUser } from "@/queries/user"

export default function RewardsScreen() {
  const { data: user } = useUser()

  const showOldRewards = user?.me?.isChannelPartner

  if (showOldRewards) {
    return <Rewards />
  }

  return <NewRewards />
}
